import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { Clock } from 'lucide-react';
export const UrgencySection: React.FC = () => {
  return <section className="py-12 bg-red-50 border-y border-red-100" data-id="element-338">
      <div className="max-w-4xl mx-auto px-4 text-center flex flex-col items-center" data-id="element-339">
        <div className="flex items-center justify-center space-x-3 mb-6" data-id="element-340">
          <Clock className="w-8 h-8 text-red-600 animate-pulse-fast" data-id="element-341" />
          <h2 className="text-2xl md:text-3xl font-black text-red-600 uppercase tracking-tight" data-id="element-342">
            Atención: Esta oferta desaparece pronto
          </h2>
        </div>
        <p className="text-gray-700 font-medium text-lg mb-8 max-w-2xl" data-id="element-343">
          Los 5 bonos gratuitos y el descuento especial del 35% solo están
          disponibles mientras el contador llegue a cero.
        </p>
        <div className="scale-125 transform origin-top" data-id="element-344">
          <CountdownTimer size="lg" theme="light" data-id="element-345" />
        </div>
      </div>
    </section>;
};